import { defineComponent as _, useSlots as l, createBlock as u, openBlock as f } from "vue";
import { vnodeTypeIsComponent as c } from "../util.js";
const B = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "Sort",
  props: {
    reverse: { type: Boolean }
  },
  setup(i) {
    const m = i, a = l();
    function y() {
      const o = a.default({});
      return o.sort((e, t) => {
        var p, s;
        const r = c(e.type) && (e.type.name || e.type.__name) === "SortBy" ? ((p = e.props) == null ? void 0 : p.weight) ?? 0 : 0, n = c(t.type) && (t.type.name || t.type.__name) === "SortBy" ? ((s = t.props) == null ? void 0 : s.weight) ?? 0 : 0;
        return (r === n ? 0 : r > n ? 1 : -1) * (m.reverse ? -1 : 1);
      }), o;
    }
    return (o, e) => (f(), u(y));
  }
});
export {
  B as default
};
